import {List} from "@hipo/react-ui-toolkit";
import classNames from "classnames";

import {AssetListItemData} from "../../../asset/util/assetModels";
import {AppStateAccountData} from "../accountTypes";
import WalletAccountListItem from "./item/WalletAccountListItem";

interface WalletAccountListProps {
  accounts: AppStateAccountData[];
  onSelect: (
    account: {detail: AppStateAccountData; assets: AssetListItemData[]},
    setInWalletAccountsAsWell?: boolean
  ) => void;
  customClassName?: string;
}

function WalletAccountList({
  accounts,
  onSelect,
  customClassName
}: WalletAccountListProps) {
  return (
    <List
      items={accounts}
      customClassName={classNames("wallet-account-list", customClassName)}
      listItemKeyGenerator={(item) => item.address}>
      {(account) => <WalletAccountListItem account={account} onSelect={onSelect} />}
    </List>
  );
}

export default WalletAccountList;
